<div class="row form">
  <div class="col-lg-12 col-md-12 col-sm-12 col-12">
    <div class="page-title-box form__head">
      <div class="row align-items-center">
        <div class="col-sm-6 col-6">
          <a class="page-title form__head__title" (click)="cancel()">
            <i class="fas fa-arrow-left m-r-5"></i>{{txtSubmenu}} empresa socia
          </a>
        </div>
        <div class="col-sm-6 col-6 form__head__boxBtn">
          <p class="m-b-0 m-t-5">Campos requeridos (<span class="required-top">*</span>)</p>
        </div>
      </div>
    </div>
  </div>
  <div class="col-lg-12">
    <div class="card m-b-30">
      <div class="card-body">
        <form validate [formGroup]="item" (ngSubmit)="onSubmit()">
          <div class="row">
            <div class="col-lg-12">
              <div class="row">
                <div class="form-group col-lg-8">
                  <label>Nombre de la empresa<span class="required"></span></label>
                  <input type="text" id="tradename" class="form-control" formControlName="tradename" autofocus>
                </div>
                <div class="form-group col-lg-4">
                  <label>N° RUC</label>
                  <input type="text" id="document" class="form-control" formControlName="document">
                </div>
                <div class="form-group col-lg-4">
                  <label>Razón social</label>
                  <input type="text" id="fullname" class="form-control" formControlName="fullname">
                </div>
                <div class="form-group col-lg-4">
                  <label>Celular</label>
                  <input type="text" class="form-control" numeric formControlName="cellphone">
                </div>
                <div class="form-group col-lg-4">
                  <label>Teléfono fijo</label>
                  <input type="text" class="form-control" numeric formControlName="telephone">
                </div>
                <div class="form-group col-lg-4">
                  <label>Correo electrónico</label>
                  <input type="email" class="form-control" formControlName="email">
                </div>
                <div class="form-group col-lg-8">
                  <label>Dirección</label>
                  <textarea rows="1" class="form-control no-resize" formControlName="address"></textarea>
                </div>                
                <div class="form-group col-lg-4">
                  <label>Fecha (aniversario)</label>
                  <input type="date" id="date_birthday" class="form-control" placeholder="yy-mm-dd"
                    formControlName="date_birthday">
                </div>
                <div class="form-group col-lg-2">
                    <label>N° trabajadores</label>
                    <input type="text" class="form-control" numeric formControlName="number_workers">
                  </div>
              </div>
            </div>
            <div class="form-group col-lg-12 form__footerBtn">
              <div class="text-right">
                <a class="btn btn-secondary text-white" (click)="cancel()">Cancelar</a>
                <button type="submit" class="btn btn-primary" [disabled]="item.invalid">
                  <i class="far fa-save m-r-5"></i>
                  <ng-container *ngIf="!isEdit">
                    Guardar
                  </ng-container>
                  <ng-container *ngIf="isEdit">
                    Guardar Cambios
                  </ng-container>
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
